import type { MonitoringModule } from "@climatepartner/app-shell/monitoring";

import { ANALYTICS_PATH } from "../routing/paths/analytics";
import { HOMESCREEN_PATH } from "../routing/paths/app";
import { COMMUNICATION_PATH } from "../routing/paths/communication";
import { CUSTOMER_ROUTE_SEGMENTS } from "../routing/paths/customer";
import { DOCUMENTS_PATH } from "../routing/paths/documents";
import { ACADEMY_PATH, CONTRIBUTE_PATH } from "../routing/paths/hub";
import { NETWORK_PATH } from "../routing/paths/network";
import { REDUCTION_PATH } from "../routing/paths/reduction";

/**
 * Pages are tagged with their module (`@context.module` on RUM, `@module` on logs), so dashboards can
 * split cfc-frontend's traffic by area. Modules moved in from a standalone frontend (analytics,
 * documents, communication, reduction) need it most: their old Datadog dashboards and monitors follow
 * them by it, because the RUM application id cannot (the SDK is initialised once per page).
 */
export const MONITORING_MODULES: MonitoringModule[] = [
  { path: ANALYTICS_PATH, module: "analytics" },
  { path: DOCUMENTS_PATH, module: "documents" },
  { path: COMMUNICATION_PATH, module: "communication" },
  { path: REDUCTION_PATH, module: "reduction" },
  { path: HOMESCREEN_PATH, module: "home" },
  { path: NETWORK_PATH, module: "network" },
  { path: `/${CUSTOMER_ROUTE_SEGMENTS.root}`, module: "calculation" },
  { path: CONTRIBUTE_PATH, module: "contribution" },
  { path: ACADEMY_PATH, module: "academy" },
];
